import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ApproveBidModal } from "./ApproveBidModal";
import { EmptyDocumentsModal } from "./EmptyDocumentsModal";
import { CONTRACT_STATUS_ENUM } from "interfaces";

export const ApproveBidButton = observer(() => {
  const { actionModals, bidCard } = useStores();

  const bidDocuments = bidCard.bid.documents;

  const allDocsUploaded = bidDocuments.INVOICE && bidDocuments.AGENT_CONTRACT && bidDocuments.AGENT_ASSIGNMENT;

  const contractIsDraft = bidCard.bid.contract.status === CONTRACT_STATUS_ENUM.DRAFT;

  const openApproveModal = () => {
    actionModals.open(() => <ApproveBidModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      onClose: () => actionModals.closeAll(),
    });
  };

  const clickHandler = () => {
    if (allDocsUploaded) {
      openApproveModal();
    } else {
      actionModals.open(() => <EmptyDocumentsModal onNextStep={openApproveModal} />, {
        width: "600px",
        noValidation: true,
        title: "Загружены не все документы, вы хотите продолжить?",
        centered: true,
        onClose: () => actionModals.closeAll(),
      });
    }
  };

  const getTooltipForButton = () => {
    if (contractIsDraft) return "Договор не активен";
    return undefined;
  };

  return (
    <CustomButton onClick={clickHandler} disabled={contractIsDraft} tooltip={getTooltipForButton()}>
      Предложить условия
    </CustomButton>
  );
});
